import React from 'react';

const TailwindTest: React.FC = () => {
  return (
    <div className="p-8 bg-gray-100 min-h-screen">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-800 mb-8">Tailwind CSS Test - Button Styles</h1>
        
        <div className="bg-white rounded-lg shadow-lg p-6 mb-8">
          <h2 className="text-xl font-semibold mb-4">Custom Button Color Palette</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {/* Primary Button */}
            <div className="space-y-2">
              <button className="btn btn-primary w-full">
                Primary Button
              </button>
              <p className="text-sm text-gray-600">#4CAF50 - Take Task, Create, Add</p>
            </div>

            {/* Secondary Button */}
            <div className="space-y-2">
              <button className="btn btn-secondary w-full">
                Secondary Button
              </button>
              <p className="text-sm text-gray-600">#FF9800 - View Task, Info</p>
            </div>

            {/* Success Button */}
            <div className="space-y-2">
              <button className="btn btn-success w-full">
                Success Button
              </button>
              <p className="text-sm text-gray-600">#9C27B0 - Complete Task, Accept</p>
            </div>

            {/* Danger Button */}
            <div className="space-y-2">
              <button className="btn btn-danger w-full">
                Danger Button
              </button>
              <p className="text-sm text-gray-600">#F44336 - Delete</p>
            </div>

            {/* Cancel Button */}
            <div className="space-y-2">
              <button className="btn btn-cancel w-full">
                Cancel Button
              </button>
              <p className="text-sm text-gray-600">#9E9E9E - Cancel, Unclaim</p>
            </div>

            {/* Info Button */}
            <div className="space-y-2">
              <button className="btn btn-info w-full">
                Info Button
              </button>
              <p className="text-sm text-gray-600">#FF9800 - Info, Warning</p>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-lg p-6 mb-8">
          <h2 className="text-xl font-semibold mb-4">Button Sizes</h2>
          
          <div className="flex flex-wrap gap-4 items-center">
            <button className="btn btn-primary btn-small">
              Small Button
            </button>
            <button className="btn btn-secondary">
              Default Button
            </button>
            <button className="btn btn-success btn-large">
              Large Button
            </button>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-lg p-6 mb-8">
          <h2 className="text-xl font-semibold mb-4">Custom Colors in Tailwind</h2>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div className="bg-btn-primary text-white p-4 rounded text-center">
              btn-primary
            </div>
            <div className="bg-btn-secondary text-btn-text-secondary p-4 rounded text-center">
              btn-secondary
            </div>
            <div className="bg-btn-success text-white p-4 rounded text-center">
              btn-success
            </div>
            <div className="bg-btn-danger text-white p-4 rounded text-center">
              btn-danger
            </div>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-lg p-6">
          <h2 className="text-xl font-semibold mb-4">Dashboard Card Colors</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="bg-dashboard-card border-l-4 border-task-available p-4 rounded shadow-md border border-dashboard-border">
              <h3 className="font-semibold">Available Tasks</h3>
              <p className="text-sm text-gray-600">Green border - #ffee93 background</p>
            </div>
            <div className="bg-dashboard-card border-l-4 border-task-active p-4 rounded shadow-md border border-dashboard-border">
              <h3 className="font-semibold">Active Tasks</h3>
              <p className="text-sm text-gray-600">Orange border - #ffee93 background</p>
            </div>
            <div className="bg-dashboard-card border-l-4 border-task-completed p-4 rounded shadow-md border border-dashboard-border">
              <h3 className="font-semibold">Completed Tasks</h3>
              <p className="text-sm text-gray-600">Purple border - #ffee93 background</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TailwindTest;
